export enum CartItemType {
    VirtualCartItem = 'VirtualCartItem',
}
